// file: src/LandlordPages/DashboardLayout.jsx (example shell)
import React from "react";
import LandlordSidebar from "./LandlordSidebar";
import LandlordSidebarMobile from "./LandlordSidebarMobile";
import FloatingSupport from "../TowingDashboard/Overview/Components/FloatingSupport";

export default function DashboardShell({ onLogout, children }) {
  return (
    <div className="min-h-screen ">
      {/* Mobile top-bar + drawer */}
      <LandlordSidebarMobile
        render={(close) => (
          <LandlordSidebar onLogout={onLogout} onClose={close} />
        )}
      />

      <div className="mx-auto grid max-w-[1400px] md:grid-cols-[18rem,1fr]">
        {/* Fixed sidebar on md+ */}
        <div className="hidden md:block sticky top-0 h-screen">
          <LandlordSidebar onLogout={onLogout} onClose={() => {}} />
        </div>

        {/* Main content area */}
        <main className="min-h-screen px-4 pb-10 pt-4 md:px-8">{children}</main>
      </div>
      <FloatingSupport
        email="support@yourspotrented.com"
        phone="+1 (331) 248-5707"
      />
    </div>
  );
}
